export default {
  name: 'marking--taskManagerLogs',
  apiService: 'shoes',
  apiPath: '/admin/task_execution_registr',
};